import React from "react";
import "../style/Footer.css";

class Footer extends React.Component {
  render() {
    return (
      <div className="footer">
        <h2 className="blog-it">BLOG IT!</h2>
      </div>
    );
  }
}

export default Footer;
